import { render, staticRenderFns } from "./stu-elog-detail.vue?vue&type=template&id=24d403ac&scoped=true&"
import script from "./stu-elog-detail.vue?vue&type=script&lang=js&"
export * from "./stu-elog-detail.vue?vue&type=script&lang=js&"
import style0 from "./stu-elog-detail.vue?vue&type=style&index=0&id=24d403ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d403ac",
  null
  
)

export default component.exports